import React, { useEffect } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import { ShopForm } from '../components/ShopForm';
import { SAVE } from '../../../../../shared/contants/actions';
import { useCreateShopMutation } from '../service/shops';
import { createFormData } from '../../../../../utils/common/createFormData';
import { ShopValues } from '../service/shop.interface';
import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { validationSchema } from '../utils/fields';

export const ShopCreateContainer = () => {
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [createShop, { isSuccess, isLoading }] = useCreateShopMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: `Магазин успешно создан`,
            });

            navigate(-1);
        }
    }, [isSuccess]);

    const initialValues = {
        name: '',
        about: '',
        photo_url: '',
        type: 0,
        create_type: 'link',
        buyable: false,
        price_from: false,
        feed_url: '',
        api_key: '',
        client_id: '',
    };

    const onSave = async (values: ShopValues) => {
        const payload: Partial<ShopValues> = {};

        for (const [key, value] of Object.entries(values)) {
            if (value === undefined || value === null || value === '') continue;

            if (key === 'photo' && !(value instanceof File)) continue;
            if (key === 'create_type') continue;

            payload[key] = value;
        }
        await createShop(createFormData(payload));
    };

    const formik = useFormik<Partial<ShopValues>>({
        initialValues,
        validationSchema,
        onSubmit: onSave,
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: false,
        enableReinitialize: true,
    });

    return (
        <GenericModal
            open
            destroyOnClose
            title={'Создать магазин'}
            okText={SAVE}
            okButtonProps={{
                disabled: isLoading || !formik.isValid || !formik.dirty,
                loading: isLoading,
            }}
            onCancel={() => {
                navigate(-1);
            }}
            onConfirm={formik.submitForm}
        >
            <ShopForm formik={formik} />
        </GenericModal>
    );
};
